import { supabase } from '../../lib/supabase';

export async function forceLogout() {
  try {
    // First clear all storage
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('sb-') || 
          key.startsWith('supabase.auth.') || 
          key.includes('token')) {
        localStorage.removeItem(key);
      }
    });

    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(';').forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });

    // Sign out from Supabase with global scope
    await supabase.auth.signOut({ scope: 'global' });
    
    // Small delay to ensure everything is cleared
    await new Promise(resolve => setTimeout(resolve, 100));

    // Force reload with cache busting
    window.location.href = `${window.location.origin}?clear=${Date.now()}`;
  } catch (error) {
    // Log the actual error details
    console.error('Force logout error:', {
      name: error?.name,
      message: error?.message,
      stack: error?.stack
    });
    
    // Still try to force reload even if there's an error
    window.location.href = `${window.location.origin}?clear=${Date.now()}`;
  }
}